<app-progress></app-progress>
<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<div class="mat-typography mt-4">
    <mat-card class="w-full md:w-1/2 mx-auto bg-gray-50 p-4">
    <mat-card-header>
      <mat-card-title>
        Facility
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form (ngSubmit)="submit()" [formGroup]="facilityForm">
        <mat-form-field class="form-field-full-width">
          <input class="form-group" formControlName="name" matInput placeholder="Facility name" required
            type="text">
          @if (facilityForm.get('name').hasError('required')) {
            <mat-error>Name is required</mat-error>
          }
          @if (facilityForm.get('name').hasError('duplicate')) {
            <mat-error>
              Facility {{facilityForm.get('name').value}} already exists
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-select formControlName="type" placeholder="Type" required>
            @for (type of types; track type) {
              <mat-option [value]="type.value">
                {{type.name}}
              </mat-option>
            }
          </mat-select>
          @if (facilityForm.get('type').hasError('required')) {
            <mat-error>Please select a Facility Type</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-field-full-width">
          <input class="form-group" formControlName="address" matInput placeholder="Facility address"
            required type="text">
          <mat-error>Address is required</mat-error>
        </mat-form-field>
        <div class="button-row">
          <button [disabled]="facilityForm.invalid" color="primary" mat-raised-button type="submit">Save
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
